import { IGroupMember } from '@omni/kit/services/GroupsService/Types';

export function sortMembers(members: IGroupMember[]): IGroupMember[] {
  return members?.slice().sort((a, b) => {
    // Normalize roles
    const roleA = a.role?.toLowerCase();
    const roleB = b.role?.toLowerCase();

    // Managers first
    if (roleA === 'manager' && roleB !== 'manager') return -1;

    if (roleA !== 'manager' && roleB === 'manager') return 1;

    // Sort by first_name (case-insensitive)
    const nameA = (a._embedded['end-user']?.first_name ?? '').toLowerCase();
    const nameB = (b._embedded['end-user']?.first_name ?? '').toLowerCase();

    return nameA.localeCompare(nameB);
  });
}
